(function ($) {
	function productSlider() {
		$(".product-slider").each(function () {
			var $this = $(this);
			var Products = new Swiper($this.find('.swiper-container')[0], {
				slidesPerView: 2,
				loop: false,
				spaceBetween: 8,
				freeMode: true,
				observer: true,
				watchOverflow: true,
				watchSlidesVisibility: true,
				mousewheel: {
					forceToAxis: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints:{
					767: {
						freeMode: false,
						slidesPerView: 3,
						spaceBetween: 12,
					},
					968: {
						freeMode: false,
						slidesPerView: 4,
						sliderPerGroup: 4,
						spaceBetween: 12,
					},
				}
			});
			// window.onresize = function () {
			// Products.init();
			// }
		});
	}
	productSlider();
	$(document).gp_ready(function (){
		productSlider();
	})

})(jQuery);
